<template>
  <el-main class="preference-container">
    <progress-line :stepList="stepList" :isPC="isPC"></progress-line>
    <PcStyle
      v-if="isPC"
      :companyCustomColor="companyCustomColor"
      :preference="preference"
      :preferenceList="preferenceList"
      :showOverlay="showOverlay"
      @back="handleBack"
      @save="handleSave"/>
    <MobileStyle
      v-else
      :companyCustomColor="companyCustomColor"
      :stepList="stepList"
      :preference="preference"
      :preferenceList="preferenceList"
      :showOverlay="showOverlay"
      @back="handleBack"
      @save="handleSave"/>
    <el-dialog
      :visible.sync="wxQrCodeIsShow"
      :width="isPC ? '35%' : '80%'"
      top="30vh">
      <div class="qrcode-container">
        <span class='title'>{{ $t('survey.title.lastStep') }}</span>
        <span class="text">{{ $t('survey.label.followUs') }}</span>
        <img :src="wxQrCodeSrc">
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import PcStyle from './pcStyle.vue'
import MobileStyle from './mobileStyle.vue'
import { mapActions, mapGetters } from 'vuex'
import ProgressLine from './progressLine.vue'
import { deviceType } from '@/utils/common'
import _ from 'lodash'

export default {
  components: {
    PcStyle,
    MobileStyle,
    ProgressLine
  },
  props: {
    isMSDCustom: {
      type: Boolean,
      default: false
    },
    customCompanyId: {
      required: false
    },
    surveyInfo: {
      type: Object,
      default: () => {}
    },
    showOverlay: {
      type: Boolean,
      required: true
    }
  },
  data () {
    const vm = this
    return {
      preference: {
        notification_type: 'wechat',
        frequency: 'weekly'
      },
      preferenceList: [
        {
          name: 'resume',
          get label () {
            return vm.$t('survey.label.submitResume')
          },
          icon: 'iconSubmitResume',
          type: 'link',
          get link () {
            return {
              path: '/recruiting/personal/resume/add',
              query: {
                back: vm.$route.fullPath,
                company_id: vm.companyId,
                only_upload_resume: 1,
                is_from_preference: 1,
                parse_resume: 1,
                is_manual_edit: 1
              }
            }
          },
          isInclude: true
        },
        {
          name: 'viewMyPreferredJobs',
          get label () {
            return vm.$t('survey.label.viewMyPreferredJobs')
          },
          icon: 'iconcandidatesurvey-23',
          type: 'link',
          get link () {
            return {
              path: `/recruiting/company/${vm.companyId}/survey/job-list-redirect`
            }
          },
          isInclude: true
        },
        {
          name: 'notification',
          get label () {
            return vm.$t('survey.label.notification')
          },
          dataKey: 'notification_type',
          icon: 'iconInternalHiring-JobAlertNotificationpreferences',
          showOptionList: false,
          optionList: [
            {
              show: true,
              get label () {
                return vm.$t('survey.notificationType.wechat')
              },
              value: 'wechat'
            },
            {
              show: true,
              get label () {
                return vm.$t('survey.notificationType.email')
              },
              value: 'email'
            },
            {
              show: true,
              get label () {
                return vm.$t('survey.notificationType.both')
              },
              value: 'both'
            }
          ]
        },
        {
          name: 'frequency',
          get label () {
            return vm.$t('survey.label.frequency')
          },
          dataKey: 'frequency',
          icon: 'iconInternalHiring-JobAlertSendingFrequency',
          showOptionList: false,
          optionList: [
            {
              show: true,
              get label () {
                return vm.$t('survey.frequency.weekly')
              },
              value: 'weekly'
            },
            {
              show: true,
              get label () {
                return vm.$t('survey.frequency.monthly')
              },
              value: 'monthly'
            },
            {
              show: true,
              get label () {
                return vm.$t('survey.frequency.off')
              },
              value: 'never'
            }
          ]
        }
      ],
      stepList: [
        {
          status: 'finish',
          labelI18nKey: 'survey.step.register'
        },
        {
          get status () {
            const surveyInfo = vm.surveyInfo
            if (surveyInfo.survey.has_answered) {
              return 'finish'
            } else {
              return 'doing'
            }
          },
          labelI18nKey: 'survey.step.survey'
        },
        {
          get status () {
            const surveyInfo = vm.surveyInfo
            if (surveyInfo.survey.has_answered) {
              return 'doing'
            } else {
              return 'pending'
            }
          },
          labelI18nKey: 'survey.step.submitResume'
        }
      ],
      wxQrCodeIsShow: false,
      wxQrCodeSrc: null
    }
  },
  computed: {
    ...mapGetters('survey', ['fromPagePath']),
    isPC () {
      return deviceType.isPc
    },
    companyId () {
      return this.customCompanyId || this.$route.params.companyId
    },
    companyCustomColor () {
      return this.surveyInfo.company && this.surveyInfo.company.color
    },
    rootCompanyId () {
      return this.surveyInfo.company.root_company_id
    },
    isFinished () {
      return this.$route.query.is_finish === 'true'
    },
    source () {
      return this.$route.query.source
    },
    code () {
      return this.$route.query.code
    }
  },
  created () {
    this.initPreferenceData()
    if (this.isFinished) {
      this.initWxQrCode()
    }
  },
  methods: {
    ...mapActions('survey', ['getSurveyPreference', 'updateSurveyPreference']),
    ...mapActions('wechat', ['getCompanyWxQrCode']),
    async initPreferenceData () {
      this.$eventBus.$emit('showLoading', true)
      if (this.rootCompanyId === 8029) {
        this.preferenceList = _.dropRight(this.preferenceList, 2)
        this.preference.notification_type = 'email'
        this.preference.frequency = 'never'
      } else if (this.rootCompanyId === 7908) {
        const preference = _.find(this.preferenceList, { name: 'notification' })
        preference.optionList[1].show = false
        preference.optionList[2].show = false
      }
      try {
        const resp = await this.getSurveyPreference({ companyId: this.companyId, source: this.source, code: this.code })
        if (resp.notification) {
          this.preference = resp.notification
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleBack () {
      const fromPagePath = this.fromPagePath
      if (fromPagePath && fromPagePath !== '/') {
        this.$router.push(fromPagePath)
      } else {
        const companyId = this.companyId
        if (this.isPC) {
          if (this.isMSDCustom) {
            window.location.href = '/msdchina/professionals'
          } else {
            window.location.href = `/company-detail-new/${companyId}/`
          }
        } else {
          if (this.isMSDCustom) {
            this.$router.push('/msdchina/jobs')
          } else {
            this.$router.push(`/mobile-web-more-jobs/${companyId}`)
          }
        }
      }
    },
    async handleSave () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const preference = {
          ...this.preference
        }
        const resp = await this.updateSurveyPreference({
          companyId: this.companyId,
          preference
        })
        if (resp) {
          this.$message.success(this.$t('survey.message.saveSuccess'))
          const fromPagePath = this.fromPagePath
          if (fromPagePath && fromPagePath !== '/') {
            this.$router.push(fromPagePath)
          } else {
            const companyId = this.rootCompanyId || this.companyId
            if (this.isPC) {
              if (this.isMSDCustom) {
                window.location.href = '/msdchina/professionals'
              } else {
                window.location.href = `/company-detail-new/${companyId}/`
              }
            } else {
              if (this.isMSDCustom) {
                this.$router.push('/msdchina/jobs')
              } else {
                this.$router.push(`/mobile-web-more-jobs/${companyId}`)
              }
            }
          }
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async initWxQrCode () {
      const resp = await this.getCompanyWxQrCode({
        company_id: this.companyId,
        preference_survey: 1
      })
      if (resp.data) {
        this.wxQrCodeSrc = 'data:image/png;base64,' + resp.data
        this.wxQrCodeIsShow = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.preference-container {
  padding: 0;
}

.qrcode-container {
  display: block;
  width: 100%;
  text-align: center;
  color: #0f0f0f;
  word-break: break-word;
  .title {
    display: block;
    margin-bottom: 10px;
    font-size: 20px;
    font-weight: bold;
  }
  .text {
    font-size: 14px;
    display: block;
    margin-bottom: 5px;
  }
  img {
    width: 38%;
    margin-top: 15px;
    margin-bottom: 20px;
  }
}

.is-mobile {
  .preference-container {
    display: flex;
    flex-direction: column;
  }
  .qrcode-container {
    img {
    width: 50%;
    }
  }
}

::v-deep {
  .el-dialog__body {
      padding: 15px 20px;
  }
}
</style>
